import { DoctorDto } from "@core/models/http/doctor-dto";
import { createAction, props } from "@ngrx/store";
import { ModuleConfiguration } from "./module-configuration";

export const loadSuccess = createAction(
    "[ModuleConfiguration] fetch success",
    props<{ moduleConfiguration: ModuleConfiguration }>()
);
export const loadFailure = createAction(
    "[ModuleConfiguration] fetch failure",
    props<{ error: string }>()
);